import {Dialog} from "../layout/modal/Dialog";
import {Button, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import React from "react";

export default ({show, title, message, confirmCaption, cancelCaption, color, onConfirm, onCancel}) => !show ? null : (
  <Dialog
    aria-labelledby='confirmation-dialog-title'
    open={true}
    onClose={onCancel}
    fullScreen={false}
  >
    <DialogTitle id='confirmation-dialog-title'>{title}</DialogTitle>
    <DialogContent style={{whiteSpace: 'pre-wrap'}}>{message}</DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>{cancelCaption}</Button>
      <Button onClick={onConfirm} color={color || 'primary'} autoFocus>{confirmCaption}</Button>
    </DialogActions>
  </Dialog>
);
